import { openDB, type DBSchema, type IDBPDatabase } from "idb";

export type QueuedOrderStatus = "pending" | "syncing" | "synced" | "failed";

export interface QueuedOrder {
  id: string;
  idempotencyKey: string;
  payload: unknown;
  createdAt: number;
  attemptCount: number;
  lastAttemptAt: number | null;
  status: QueuedOrderStatus;
  error: string | null;
  serverOrderId: string | null;
}

interface OfflineDB extends DBSchema {
  pending_orders: {
    key: string;
    value: QueuedOrder;
    indexes: {
      "by-status": QueuedOrderStatus;
      "by-created": number;
    };
  };
}

const DB_NAME = "coffee-pos-offline";
const DB_VERSION = 1;

let dbPromise: Promise<IDBPDatabase<OfflineDB>> | null = null;

export function getOfflineDb(): Promise<IDBPDatabase<OfflineDB>> {
  if (!dbPromise) {
    dbPromise = openDB<OfflineDB>(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains("pending_orders")) {
          const store = db.createObjectStore("pending_orders", {
            keyPath: "id",
          });
          store.createIndex("by-status", "status");
          store.createIndex("by-created", "createdAt");
        }
      },
    });
  }

  return dbPromise;
}
